module.exports = __webpack_public_path__ + "static/img/officialaccount.02a75da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chineseMedicine/officialaccount.jpg
// module id = 2cyF
// module chunks = 59